import { cn } from '../../lib/cn';

export function DatabinexMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" className={cn('size-11', className)}>
      <path d="M32 4 53 17 49 46 32 59 15 46 11 17Z" fill="none" stroke="currentColor" strokeWidth="3" />
      <path d="m17 19 15 12 15-12M17 45l15-14 15 14M32 8v23M32 31v24" fill="none" stroke="currentColor" strokeWidth="2.5" opacity=".65" />
      <circle cx="32" cy="31" r="5" fill="#F26A21" />
      <circle cx="32" cy="7" r="3.5" fill="#7C3AED" />
      <circle cx="13" cy="18" r="3.5" fill="#2563EB" />
      <circle cx="51" cy="18" r="3.5" fill="#F59E0B" />
    </svg>
  );
}

export function BrandLockup({ inverse = false, compact = false }: { inverse?: boolean; compact?: boolean }) {
  return (
    <div className={cn('flex items-center gap-3', inverse ? 'text-white' : 'text-ink')}>
      <DatabinexMark className="text-plum" />
      {!compact && (
        <div className="leading-none">
          <div className="font-black tracking-tight">DataBinex</div>
          <div className={cn('mt-1 text-[10px] font-bold tracking-[.16em]', inverse ? 'text-white/55' : 'text-slate-400')}>T-SQL ARENA</div>
        </div>
      )}
    </div>
  );
}
